// index.js or main file
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import Login from './pages/login/login';
import AdminRedirect from './adminRedirect/admin';
import Admin from './admin/admin';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import LoginPage from './admin/pages/login/login';
import USER from './pages/dddUI/user';
import LsThemeHome from './admin/pages/learningStyle/ThemeHome';
import LsRulesAdmin from './admin/pages/learningStyle/Rules';
import LsQuestions from './admin/pages/learningStyle/Questions';
import LsCategorySettings from './admin/pages/learningStyle/CategorySettings';
import LsRules from './pages/learningStyle/Rules';
import LsQuiz from './pages/learningStyle/Quiz';
import LsThankYou from './pages/learningStyle/ThankYou';

function usePageBackground() {
  const location = useLocation();
  useEffect(() => {
    const body = document.body;
    const path = location.pathname;
    /** Routes that set their own full-viewport theme image — skip index.css `common-bg` (img/background.jpg) to avoid double layers */
    const ownBackdrop = /^\/leaderboard\/?$/i.test(path);
    if (path.startsWith("/admin")) {
      body.classList.remove("common-bg");
    } else if (ownBackdrop) {
      body.classList.remove("common-bg");
    } else {
      body.classList.add("common-bg");
    }
  }, [location]);
}

function App() {
  usePageBackground();

  return (
    <Provider store={store}>
      <Routes>
        {/* Explicit paths (most specific first) so /admin always = Learning Style admin, never the superadmin login */}
        <Route path="/admin/superadmin" element={<LoginPage />} />
        <Route path="/admin/theme" element={<Admin><LsThemeHome /></Admin>} />
        <Route path="/admin/rules" element={<Admin><LsRulesAdmin /></Admin>} />
        <Route path="/admin/questions" element={<Admin><LsQuestions /></Admin>} />
        <Route path="/admin/category-settings" element={<Admin><LsCategorySettings /></Admin>} />
        <Route path="/admin" element={<Navigate to="/admin/theme" replace />} />

        <Route path="*" element={
          <USER>
            <Routes>
              <Route index element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/AdminRedirect" element={<AdminRedirect />} />
              <Route path="/rules" element={<LsRules />} />
              <Route path="/quiz" element={<LsQuiz />} />
              <Route path="/thankyou" element={<LsThankYou />} />
            </Routes>
          </USER>
        } />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
